<script>
export default {
    name: 'ComponentsFooter',
}
</script>
<template>
    <div class="d-flex flex-1 flex-column">
        <div class="d-flex flex-1 justify-content-center">
            <strong>Kontakt:</strong>&nbsp; biuro@zzwg.pl
        </div>
        <footer>
            <div class="container">
            </div>
        </footer>
    </div>
</template>
